import { apiSlice } from "../apiSlice";
import { COURSES_URL } from "../../constants";

export const courseApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createCourse: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/createcourse`,
              method: 'POST',
              body: data,
            }),
          }),
          saveActiveLesson: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/saveactivelesson`,
              method: 'POST',
              body: data,
            }),
          }),        
          getCourse: builder.query({
            query: (id) => ({
              url: `${COURSES_URL}/getcourse/${id}`,
            }),
          }),
          createLesson: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/createlesson`,
              method: 'POST',
              body: data,
            }),
          }),
          deleteLesson: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/deletelesson`,
              method: 'POST',
              body: data,
            }),
          }),
          updateLesson: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/updatelesson`,
              method: 'POST',
              body: data,
            }),
          }),
          publishCourse: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/publishcourse`,
              method: 'POST',
              body: data,
            }),
          }),
          addSection: builder.mutation({
            query: (data) => ({
              url: `${COURSES_URL}/addsection`,
              method: 'POST',
              body: data,
            }),
          }),                
    }),
});


export const { 
    useCreateCourseMutation,
    useDeleteLessonMutation,
    useSaveActiveLessonMutation,
    useGetCourseQuery,
    useAddSectionMutation,
    useUpdateLessonMutation,
    usePublishCourseMutation,
    useCreateLessonMutation
  } = courseApiSlice;
      